import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Typography, Input, Space } from 'antd';

import { SpacedText, StretchedFormItem } from './styledComponents';
import { InfoCircleOutlined } from '@ant-design/icons';
import PolicyAndMemberIdModal from 'pages/forget/PolicyAndMemberIdModal';

const { Title, Text } = Typography;

const MemberInformationCard = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const infoIcon = <InfoCircleOutlined onClick={() => setIsModalVisible(true)} style={{ cursor: 'pointer' }} />;

  return (
    <>
      <Card bodyStyle={{ paddingBottom: 0 }} title={<Title level={4}>{t('migration.existingMemberInfo')}</Title>}>
        <Space size={16} direction="vertical">
          <SpacedText type="secondary">{t('migration.memberLoginDescription')}</SpacedText>
          <StretchedFormItem
            required
            name="policyNumber"
            label={<Text strong>{t('migration.policyNo')}</Text>}
            rules={[
              {
                required: true,
                message: t('migration.error.policyNumberIsRequired'),
              },
              {
                max: 8,
                message: t('migration.error.policyNumberWrongLength', { digit: '8' }),
              },
            ]}
            tooltip={{ icon: infoIcon }}
            validateTrigger="onSubmit"
          >
            <Input placeholder={t('migration.policyNoPlaceholder')} />
          </StretchedFormItem>
          <StretchedFormItem
            required
            name="memberId"
            label={<Text strong>{t('migration.memberId')}</Text>}
            rules={[
              {
                required: true,
                message: t('migration.error.memberIdIsRequired'),
              },
              {
                max: 12,
                message: t('migration.error.memberIdWrongLength', { digit: '12' }),
              },
            ]}
            tooltip={{ icon: infoIcon }}
            validateTrigger="onSubmit"
          >
            <Input placeholder={t('migration.memberIdPlaceholder')} />
          </StretchedFormItem>
          <StretchedFormItem
            label={<Text strong>{t('migration.passwordLabel')}</Text>}
            name="password"
            rules={[{ required: true, message: t('migration.error.passwordIsRequired') }]}
            validateTrigger="onSubmit"
          >
            <Input.Password placeholder={t('migration.passwordPlaceholder')} />
          </StretchedFormItem>
        </Space>
      </Card>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={() => setIsModalVisible(false)} />
    </>
  );
};

export default MemberInformationCard;
